import React from "react";

const TextWrapper = ({ text }) => {
  return <textarea className="text-wrapper">{text}</textarea>;
};

export default TextWrapper;
